import React from 'react';
import styles from './Thumbnails.module.scss';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_TIMELINE_STORE } from 'store';
import { SpriteFrame } from 'components/editor';
import { ThumbnailsProps } from './types';

const Thumbnails = (props: ThumbnailsProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      timelineThumbnailsToView: thumbnails,
      setCurrentMonitorFrame
    }
  } = props;

  return (
    <div className={styles.container}>
      {thumbnails.map((thumbnail, index) => {
        const isFirst = index === 0;
        const isLast = index === (thumbnails.length - 1);

        return (
          <div key={index} className={styles.thumbnail}>
            <div
              className={styles.marker}
              style={{
                backgroundColor: thumbnail.isEven ? styles.grey : styles.lightGrey,
                borderTopLeftRadius: isFirst ? 3 : 0,
                borderBottomLeftRadius: isFirst ? 3 : 0,
                borderTopRightRadius: isLast ? 3 : 0,
                borderBottomRightRadius: isLast ? 3 : 0
              }}
              title={thumbnail.title}
            />
            <div
              className={styles.spriteFrameContainer}
              onClick={() => setCurrentMonitorFrame(thumbnail.frame)}
            >
              <SpriteFrame
                frameNumber={thumbnail.frame}
                showNumber
                size='xs'
              />
            </div>
          </div>
        );
      }
      )}

    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE)(observer(Thumbnails));
